import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    openSidebar: false,
    showSidebar: false
};

export const sidebarSlice = createSlice({
    name: "sidebarSlice",
    initialState,
    reducers: {
        setSidebar: (state, action) => {
            state.openSidebar = action.payload;
        },
        setShowSidebar: (state, action) => {
            state.showSidebar = action.payload;
        }
    },
});

export const { setSidebar, setShowSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
